import React, { useEffect, useState } from "react";
import { useRouter } from 'next/router';
import { DateTime } from "luxon";

import { getStatusRide } from "@services/api";
import { getBotInfo } from "@services/bot/botServices";
import { getMission } from "@services/mission/missionService";
import { getRideExperienceActivity } from "@services/ride/rideService";
import { displayElapsedTimeFromRide } from "@utils/time";

import ArrowBack from "@images/profile/arrow_back.svg";
import FrodobotOrange from "@images/profile/frodobotOrange.svg";

const Transcript = ({ rideId, close }) => {
  const [ride, setRide] = useState(undefined);
  const [bot, setBot] = useState(undefined);
  const [mission, setMission] = useState(undefined);
  const [experienceActivity, setExperienceActivity] = useState(undefined);

  useEffect(() => {
    if (rideId) {
      setBot(undefined);
      setMission(undefined);
      fetchRide(rideId);
      fetchExperienceActivity(rideId);
    }
  }, [rideId])

  const fetchRide = async (rideId) => {
    const response = await getStatusRide(rideId);
    if (response && response?.ride && response?.ride?.id) {
      setRide(response.ride);
    }
    if (response && response.ride && response?.ride?.mission_id) {
      fetchMission(response.ride.mission_id);
    }
  }

  const fetchExperienceActivity = async (rideId) => {
    const response = await getRideExperienceActivity(rideId);
    if (response && response.experience_activity) {
      setExperienceActivity(response.experience_activity)
    }
  }

  const fetchMission = async (missionId) => {
    const response = await getMission(missionId);
    if (response && response.mission) {
      setMission(response.mission);
    }
    if (response && response.mission && response?.mission?.bot_id) {
      fetchBot(response.mission.bot_id);
    }
  }

  const fetchBot = async (botId) => {
    const response = await getBotInfo(botId);
    if (response && response.bot) {
      setBot(response.bot);
    }
  }

  if (!ride || !mission || !bot) {
    return (
      <div className="flex justify-between items-center w-full">
        <button onClick={close} className="bg-black px-[12px] text-[16px] py-[10px] text-white flex gap-[4px] rounded-full">
          <img src={ArrowBack} alt="Go back" /> Go back
        </button>
      </div>
    );
  }

  return (
    <>
      <div className="flex justify-between items-center w-full">
        <button onClick={close} className="bg-black px-[12px] text-[16px] py-[10px] text-white flex gap-[4px] rounded-full">
          <img src={ArrowBack} alt="Go back" /> Go back
        </button>
      </div>
      <div className="max-w-[512px] mx-auto lg:mt-[56px] md:mt-[32px] mt-[16px] flex flex-col gap-[20px]">
        <p className="text-black text-[42px] leading-[42px] max-w-[406px] mx-auto font-semibold text-center">
          {DateTime.fromISO(ride.created_at).toLocaleString({ month: 'long', day: 'numeric' })}, {mission.name}
        </p>
        <div className="bg-white rounded-2xl p-[16px] flex flex-col gap-[16px]">
          <div className="grid grid-cols-3">
            <div className="col-span-2">
              <img src={FrodobotOrange} alt="Frodobot" />
              <p className="text-black text-[24px] leading-[32px]">{bot.name}</p>
            </div>
            <div className="flex flex-col justify-end">
              <button
                className="bg-black text-white px-[10px] py-[10px] rounded-full flex gap-[4px] text-[16px] font-semibold"
                onClick={() => (window.location = `/bot/${bot.id}`)}
                // onClick={() => navigate(`/bot/${bot.id}`)}
              >
                <img src={ArrowBack} className="rotate-[134px]" alt="Visit FrodoBot" />
                Visit FrodoBot
              </button>
            </div>
          </div>
        </div>
        <div className="bg-white rounded-2xl">
          <div className="grid grid-cols-2 gap-[24px] p-[32px]">
            <InfoBlock label="XP Earned" value={experienceActivity?.amount || "-"} />
            <InfoBlock label="Checkpoints" value={mission.checkpoints?.length || "-"} />
            <InfoBlock label="Time elapsed" value={ride.end_time ? displayElapsedTimeFromRide(ride) : "-"} />
          </div>
        </div>
      </div>
    </>
  );
};

const InfoBlock = ({ label, value }) => (
  <div>
    <div className="text-[32px] text-black font-semibold">{value}</div>
    <p className="text-gray text-[18px] leading-[28px]">{label}</p>
  </div>
);

export default Transcript;
